import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { getFormattedDate } from 'helpers/datetime';

import { FormattedMessage } from 'react-intl';

import { getOrderDate, getTimeSlotPeriod } from 'stores/UserProfile/helpers';
import { OrderState } from 'stores/UserProfile/types';
import OnlineOrderModalStore from 'stores/Modals/OnlineOrderModalStore';

import style from './OnlineOrder.module.scss';
import FormattedCurrency from 'components/FormattedCurrency/FormattedCurrency';
import OrderItemsList from 'components/OrderItemsList/OrderItemsList';
import Alert from 'components/Alert/Alert';
import Button from 'components/Button/Button';

@observer
class OnlineOrder extends Component<{
  store: OnlineOrderModalStore;
  onUpdateOrderState: (id: string, state: OrderState) => void;
}> {
  handleCancelRequestConfirm = async () => {
    const { store, onUpdateOrderState } = this.props;

    await store.confirmCancelRequest(store.order.id, () =>
      onUpdateOrderState(store.order.id, OrderState.CANCELLED),
    );
  };

  handleCancelRequestDecline = async () => {
    const { store, onUpdateOrderState } = this.props;

    await store.declineCancelRequest(store.order.id, () =>
      onUpdateOrderState(store.order.id, OrderState.DECLINE_CANCEL),
    );
  };

  render() {
    const { store } = this.props;

    const {
      deliveryTimeSlot,
      deliveryInfo,
      deliveryLocation,
      items,
      queueNumber,
      deliveryDate,
      finalPrice,
      createdDate,
      state,
      orderProcessingFinished,
    } = store.order;

    const isRequestedToCancel =
      state === OrderState.CANCEL_REQUESTED && !orderProcessingFinished;

    return (
      <div className={style.order}>
        <div className={style.order__line}>
          <div className={style.order__info}>
            <p className={style.order__number}>{queueNumber}</p>
            <div className={style.order__info__line}>
              {getOrderDate(createdDate)}
            </div>

            {deliveryTimeSlot && (
              <div className={style.order__info__line}>
                <FormattedMessage
                  id="user.orders.delivery.period"
                  values={{ period: getTimeSlotPeriod(deliveryTimeSlot) }}
                />
              </div>
            )}

            <div className={style.order__info__line}>
              <FormattedMessage
                id="user.orders.delivery.on"
                values={{
                  date: getFormattedDate(deliveryDate),
                }}
              />
            </div>

            <div className={style.order__info__line}>
              {deliveryLocation?.title || deliveryInfo?.pointOfDelivery ? (
                <>
                  <FormattedMessage id="user.orders.delivery.label" />
                  &nbsp;
                  {deliveryLocation?.title || deliveryInfo?.pointOfDelivery}
                </>
              ) : (
                <FormattedMessage id="user.orders.delivery.pickup.label" />
              )}
            </div>

            {deliveryInfo && (
              <>
                {deliveryInfo?.email && (
                  <div className={style.order__info__line}>
                    <FormattedMessage id="user.orders.delivery.email.label" />
                    &nbsp;
                    {deliveryInfo.email}
                  </div>
                )}
                {deliveryInfo?.phone && (
                  <div className={style.order__info__line}>
                    <FormattedMessage id="user.orders.delivery.phone.label" />
                    &nbsp;
                    {deliveryInfo.phone}
                  </div>
                )}
                {deliveryInfo?.comment && (
                  <div className={style.order__info__line}>
                    <FormattedMessage id="user.orders.delivery.comment.label" />
                    &nbsp;
                    {deliveryInfo.comment}
                  </div>
                )}
              </>
            )}
          </div>

          <span className={style.price}>
            <FormattedCurrency value={finalPrice} />
          </span>
        </div>

        <OrderItemsList
          items={items}
          styles={{
            list: style.order__items,
            item: style.order__item,
            childItem: style.order__childItem,
            childList: style.order__childList,
          }}
          recent={false}
        />

        {isRequestedToCancel && (
          <Alert color="warning" className={style.alert}>
            <div className={style.alertText}>
              <FormattedMessage id="title.requestToCancel" />
            </div>
            <div className={style.alertActions}>
              <Button
                className={style.alertBtn}
                disabled={store.isLoading}
                onClick={this.handleCancelRequestConfirm}
              >
                <FormattedMessage id="button.confirm" />
              </Button>
              <Button
                styleType="warning"
                className={style.alertBtn}
                disabled={store.isLoading}
                onClick={this.handleCancelRequestDecline}
              >
                <FormattedMessage id="button.decline" />
              </Button>
            </div>
          </Alert>
        )}
      </div>
    );
  }
}

export default OnlineOrder;
